export const DEFAULT_TIME_ZONE_NAME = 'Europe/Paris';
